import {
  createStore,
  applyMiddleware,
  compose
} from 'redux';
import {
  createLogger
} from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import createHistory from 'history/createBrowserHistory';
import {
  routerMiddleware
} from 'react-router-redux';
import rootReducer from './reducers';
import sagas from './sagas';

let middleware = [];
const sagaMiddleware = createSagaMiddleware();

export const history = createHistory();

middleware.push(sagaMiddleware);
const logger = createLogger({
  collapsed: true,
  stateTransformer: (state) => {
    let tState = {};

    Object.keys(state).forEach(key => {
      if (typeof state[key].toJS === 'function') {
        tState[key] = state[key].toJS({ deep: true });
      } else {
        tState[key] = state[key];
      }
    });

    return tState;
  }
});

middleware.push(logger);
middleware.push(routerMiddleware(history));

export default () => {
  const enhancers = compose(
    applyMiddleware(...middleware)
  );

  let store = createStore(
    rootReducer,
    enhancers
  );

  sagaMiddleware.run(sagas);

  return store;
};




// WEBPACK FOOTER //
// ./client/store/Store.js